import React from 'react';

import { angularizeWithProviders } from '../../../../../shared/providers';
import { EntityLoginIdBlock } from './containers/EntityLoginIdBlock/EntityLoginIdBlock';
import { EntityPasswordBlock } from './containers/EntityPasswordBlock/EntityPasswordBlock';

type NgzLoginIdPasswordTabProps = {
  entityId: number;
  entityUserId: number;
};

const NgzLoginIdPasswordTab = ({
  entityId,
  entityUserId,
}: NgzLoginIdPasswordTabProps) => {
  return (
    <>
      <EntityLoginIdBlock entityId={entityId} />
      <EntityPasswordBlock entityUserId={entityUserId} entityId={entityId} />
    </>
  );
};

angularizeWithProviders(NgzLoginIdPasswordTab, 'ngzLoginIdPasswordTab', {
  entityId: '<',
  entityUserId: '<',
});

export { NgzLoginIdPasswordTab };
